<!-- Table -->
<p-table styleClass="border-1 border-300 border-top-none" [scrollable]="true" selectionMode="single"
    [value]="freeze$ | async" responsiveLayout="scroll" aria-label="freeze list table" data-testid="freeze-list-table">
    <ng-template pTemplate="header">
        <tr>
            <th class="surface-100">
                <span class="text-xs text-600 white-space-nowrap uppercase" data-testid="start-date-header">
                    {{ 'FREEZE.FREEZE_LIST.STARTDATE' | translate }}
                </span>
            </th>
            <th class="surface-100">
                <span class="text-xs text-600 white-space-nowrap uppercase" data-testid="end-date-header">
                    {{ 'FREEZE.FREEZE_LIST.ENDDATE' | translate }}
                </span>
            </th>
            <th class="surface-100">
                <span class="text-xs text-600 white-space-nowrap uppercase" data-testid="status-header">
                    {{ 'FREEZE.FREEZE_LIST.STATUS' | translate }}
                </span>
            </th>
            <th class="surface-100" *ngIf="!isSidebarView">
                <span class="text-xs text-600 white-space-nowrap uppercase" data-testid="updated-by-header">
                    {{ 'FREEZE.FREEZE_LIST.UPDATEDBY' | translate }}
                </span>
            </th>
            <th class="surface-100" *ngIf="!isSidebarView">
                <span class="text-xs text-600 white-space-nowrap uppercase" data-testid="updated-on-header">
                    {{ 'FREEZE.FREEZE_LIST.UPDATEDON' | translate }}
                </span>
            </th>
            <th class="surface-100">
                <span class="text-xs text-600 white-space-nowrap uppercase"></span>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-tableData>
        <tr class="text-sm hover:surface-100" [attr.data-testid]="'freeze-row-' + tableData.freeze_id">
            <td class="py-2 white-space-nowrap" [attr.data-testid]="'start-date-' + tableData.freeze_id">
                {{ ConvertToLocalTimezone(tableData.start_date) | date:'dd MMM yyyy' }}
            </td>
            <td class="py-2 white-space-nowrap" [attr.data-testid]="'end-date-' + tableData.freeze_id">
                {{ ConvertToLocalTimezone(tableData.end_date) | date:'dd MMM yyyy' }}
            </td>
            <td class="py-2 white-space-nowrap" [attr.data-testid]="'status-' + tableData.freeze_id">
                {{ tableData.status }}
            </td>
            <td class="py-2 white-space-nowrap" *ngIf="!isSidebarView" [attr.data-testid]="'updated-by-' + tableData.freeze_id">
                <ng-container *ngIf="GetStaff(tableData.updated_by) | async as updatedBy">
                    <div class="" pStyleClass="@next" enterFromClass="hidden" enterActiveClass="scalein"
                        leaveToClass="hidden" leaveActiveClass="fadeout" [hideOnOutsideClick]="true">
                        <span class="text-primary cursor-pointer flex align-items-center">
                            <ng-container *ngIf="updatedBy?.ff_picture">
                                <p-avatar image="{{updatedBy.ff_picture}}" styleClass="mr-2 overflow-hidden">
                                </p-avatar>
                            </ng-container>
                            <ng-container *ngIf="!updatedBy?.ff_picture">
                                <p-avatar styleClass="mr-2 overflow-hidden"
                                    [label]="updatedBy?.name | titlecase | shortName">
                                </p-avatar>
                            </ng-container>
                            {{updatedBy?.name}}
                        </span>
                    </div>

                    <div class="border-round shadow-2 absolute text-600 hidden origin-top w-22rem z-2"
                        style="margin-top: 9rem !important" [attr.data-testid]="'staff-details-' + tableData.freeze_id">
                        <!-- Dropdown Content -->
                        <div class="surface-0 -mx-4 -mt-4 flex align-items-center justify-content-between p-3 text-sm">
                            <div class="flex align-items-center">
                                <span class="text-base font-medium text-800">
                                    {{updatedBy?.name}}
                                </span>
                                <span class="text-xs text-600 ml-3">
                                    {{updatedBy?.id}}
                                </span>
                            </div>
                            <span
                                class="bg-blue-50 px-2 py-1 font-bold border-round border-1 border-primary text-primary text-xxs uppercase ml-4 mt-1">
                                {{updatedBy?.designation}}
                            </span>
                        </div>
                        <!-- Dropdown Content -->

                        <!-- Dropdown Footer -->
                        <div
                            class="p-3 -mx-4 -mb-4 flex align-items-center justify-content-between surface-200 text-800">
                            <div class="flex align-items-center mr-4">
                                <i class="fa fa-phone mr-2 text-500"></i>
                                {{updatedBy?.mobile_country_code + " " +
                                updatedBy?.mobile_number || ""}}
                            </div>
                            <div class="flex align-items-center">
                                <i class=" fa fa-envelope font-light mr-2 text-500"></i>
                                {{updatedBy?.email_id}}
                            </div>
                        </div>
                        <!-- Dropdown Footer -->
                    </div>
                </ng-container>
            </td>
            <td class="py-2 white-space-nowrap" *ngIf="!isSidebarView" [attr.data-testid]="'updated-on-' + tableData.freeze_id">
                {{ tableData.updated_date | datetimeformat:'ukformat' }}
            </td>
            <td class="py-3 white-space-nowrap text-right">
                <button *ngIf="ShowEditOption(tableData) || ShowCancelOption(tableData) || ShowStopOption(tableData)"
                    pButton pRipple type="button" icon="fa fa-angle-down" [label]="'common.BUTTONS.BTN_ACTIONS' | translate" iconPos="right"
                    class="text-sm text-600 p-button-outlined p-button-secondary border-400 p-2"
                    (click)="createdBy.toggle($event)" [attr.aria-label]="'actions for freeze ' + tableData.freeze_id" [attr.data-testid]="'actions-button-' + tableData.freeze_id">
                </button>
                <p-popover #createdBy styleClass="overflow-hidden right-0 text-sm w-6rem -ml-2" aria-label="actions menu" data-testid="actions-menu">
                    <ng-template #content>
                        <ul class="list-none -m-4 py-2 px-0 text-xs text-600" (mouseover)="showOptions=true">
                            <li *ngIf="ShowEditOption(tableData) && !IsContract(tableData)" (click)="ShowEditFreeze(tableData)"
                                class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" [attr.aria-label]="'edit freeze ' + tableData.freeze_id" [attr.data-testid]="'edit-freeze-' + tableData.freeze_id">
                                <i class="fa fa-pencil text-xs mr-2"></i>
                                {{ 'FREEZE.FREEZE_LIST.EDIT' | translate }}
                            </li>
                            <li *ngIf="ShowCancelOption(tableData)" (click)="ShowCancelFreeze(tableData)"
                                class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" [attr.aria-label]="'void freeze ' + tableData.freeze_id" [attr.data-testid]="'void-freeze-' + tableData.freeze_id">
                                <i class="fa fa-ban text-xs mr-2"></i>
                                {{ 'FREEZE.FREEZE_LIST.VOID' | translate }}
                            </li>
                            <li *ngIf="ShowStopOption(tableData)" (click)="ShowStopFreeze(tableData)"
                                class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" [attr.aria-label]="'stop freeze ' + tableData.freeze_id" [attr.data-testid]="'stop-freeze-' + tableData.freeze_id">
                                <i class="fa fa-minus-circle text-xs mr-2"></i>
                                {{ 'FREEZE.FREEZE_LIST.STOP' | translate }}
                            </li>
                        </ul>
                    </ng-template>
                </p-popover>
            </td>
        </tr>
    </ng-template>
</p-table>
<!-- Table -->

<freeze-edit *ngIf="editFreeze$ | async as visible" [visible]="visible" [freeze]="selectedEditFreeze$"
    (hidePopup)="HideEditFreeze($event)" aria-label="edit freeze dialog" data-testid="edit-freeze-dialog">
</freeze-edit>

<freeze-cancel *ngIf="cancelFreeze$ | async as visible" [visible]="visible" [freeze]="selectedCancelFreeze$"
    (hidePopup)="HideCancelFreeze($event)" aria-label="cancel freeze dialog" data-testid="cancel-freeze-dialog">
</freeze-cancel>

<freeze-stop *ngIf="stopFreeze$ | async as visible" [visible]="visible" [freeze]="selectedStopFreeze$"
    (hidePopup)="HideStopFreeze($event)" aria-label="stop freeze dialog" data-testid="stop-freeze-dialog">
</freeze-stop>